import type { ExtractPropTypes } from 'vue'

export const notificationWebProps = {
  profileCardIsOpen: {
    type: Boolean,
    required: true,
  },
  appLauncherIsOpen: {
    type: Boolean,
    required: true,
  },
  notificationListIsOpen: {
    type: Boolean,
    required: true,
  },
  position: {
    type: String,
    required: true,
  },
} as const

export type NotificationWebProps = Readonly<ExtractPropTypes<typeof notificationWebProps>>

export interface NotificationWebEmit {
  (e: 'update:notificationListIsOpen'): void
}
